import {priority} from '@priority-software/priority-proto-api/lib';
import {DateEnum} from '../features/AppSearches/types/filters';
import {getDateRangesMap} from '../common/dateRange';
import {formatDate, isIsoDate} from '../features/Form/utils/date';

export const getFormattedDates = (
    dates: string[],
    type: priority.netitems.form.ColumnType,
    dateEnum: DateEnum[]
) => {
    return dates?.map((date, idx) => {
        const wildcard = /\*|\?/g;
        //no need to fromat date if has wildcards or already formated
        if (!date || wildcard.test(date) || (date as string)?.includes('/')) {
            return date;
        }
        const dateRanges = getDateRangesMap();
        const dateAsRang = dateEnum ? dateRanges[dateEnum[idx]] : dateRanges[date];
        const fixDate: Date = dateAsRang
            ? dateAsRang.getDate()
            : isIsoDate(date)
            ? new Date(date)
            : '';
        if (fixDate.toString() === 'Invalid Date') {
            return date;
        }
        //format only if date range or isoDate
        if (fixDate) {
            return formatDate(fixDate, type);
        }
        return date;
    });
};
